import React from "react";
import "./HomeDesign.scss";

const HomeDesign = () => {
  return (
    <section className="section homeDesign">
      <article className="homeDesign__container container">
        <div className="homeDesign__container--header">
          <h2>Our</h2>
          <h3>Process</h3>
        </div>
        <div className="homeDesign__container--contents">
          <div className="contents__item">
            <p className="num active-num">1</p>
            <h3 className="title">Initial Consultation</h3>
            <p className="subtitle">
              This initial conversation allows us to understand your business
              needs, goals, and challenges.
            </p>
          </div>

          <div className="contents__item">
            <p className="num">2</p>
            <h3 className="title">Talent Selection</h3>
            <p className="subtitle">
              We match user needs with the most suitable talent from our global
              pool, based on skills, experience, and project requirements.
            </p>
          </div>

          <div className="contents__item">
            <p className="num">3</p>
            <h3 className="title">Project Onboarding & Management</h3>
            <p className="subtitle">
              We provide a dedicated project manager to oversee communication,
              progress tracking, and address any concerns throughout the project
              lifecycle.
            </p>
          </div>

          <div className="contents__item">
            <p className="num">4</p>
            <h3 className="title">Project Completion</h3>
            <p className="subtitle">
              Upon completion of the project, the user receives the final
              deliverables and undergoes a final review process.
            </p>
          </div>

          <div className="contents__item">
            <p className="num">5</p>
            <h3 className="title">Revision & Feedback</h3>
            <p className="subtitle">
              We go over the completed project together to harvest any feedbacks
              you might have.
            </p>
          </div>
        </div>
      </article>
    </section>
  );
};

export default HomeDesign;
